// Central site configuration for The Family Legacy Bridge marketing site.

export const CONTACT_EMAIL = 'amyjaffe@outlook.com';

// Google Calendar Appointment Schedule (creates a Google Meet on booking).
// Hardcoded default so every "Request a conversation" CTA works without any
// deployment configuration; still overridable via REACT_APP_BOOKING_URL.
const BOOKING_URL =
  process.env.REACT_APP_BOOKING_URL ||
  'https://calendar.app.google/sn8Cz3RHWna9qfHP9';

const BOOKING_FALLBACK =
  `mailto:${CONTACT_EMAIL}` +
  `?subject=${encodeURIComponent('Introductory conversation — The Family Legacy Bridge')}` +
  `&body=${encodeURIComponent(
    "Hello Amy,\n\nI'd like to arrange an introductory conversation about working with my family.\n\n"
  )}`;

export const bookingHref = BOOKING_URL || BOOKING_FALLBACK;
export const bookingIsExternal = Boolean(BOOKING_URL);
